"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClientIdentity = /** @class */ (function () {
    function ClientIdentity(props) {
        this.clientId = props.clientId;
        this.clientReference = props.clientReference;
        this.firstName = props.firstName;
        this.lastName = props.lastName;
        this.email = props.email;
        this.telephone = props.telephone;
        this.civilityCode = props.civilityCode;
        this.socialReason = props.socialReason;
        this.siren = props.siren;
        this.siret = props.siret;
        this.sensitivityCode = props.sensitivityCode;
        this.isExemptFromVat = props.isExemptFromVat;
        this.roleCode = props.roleCode;
        this.naceCode = props.naceCode;
        this.nafCode = props.nafCode;
        this.categoryCode = props.categoryCode;
        this.regionCode = props.regionCode;
        this.lastConnectionDate = props.lastConnectionDate;
        this.addressId = props.addressId;
        this.tenantId = props.tenantId;
        this.defaultContractId = props.defaultContractId;
        this.defaultDeliveryPointId = props.defaultDeliveryPointId;
        this.createdAt = props.createdAt;
        this.createdBy = props.createdBy;
        this.updatedAt = props.updatedAt;
        this.updatedBy = props.updatedBy;
        this.contactByMobile = props.contactByMobile;
        this.contactByEmail = props.contactByEmail;
        this.contactByLandline = props.contactByLandline;
        this.landLineNumber = props.landLineNumber;
        this.mobileNumber = props.mobileNumber;
        this.address = props.address;
    }
    return ClientIdentity;
}());
exports.default = ClientIdentity;
